import { RootState } from 'reducers';


export const AuthSelector = ({ AuthReducer }: RootState) => {
  return {
    ...AuthReducer
  };
}